import { Hyperlink } from '@strata/react-hyperlink';

import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const startHere = [
    <ul key="1">
        <li>
            Familiarize yourself with the{' '}
            <Hyperlink linkText="Color Palette" navUrl="/color-palette" openInNewTab={false} /> and{' '}
            <Hyperlink linkText="Design Tokens" navUrl="/design-tokens" openInNewTab={false} />.
            This is the source of truth for styling the UI and creating consistency across our
            products.
        </li>
        <li>
            Get to know what&#39;s available in the reusable{' '}
            <Hyperlink linkText="Utility Classes" navUrl="/utility-classes" openInNewTab={false} />{' '}
            to help with easy and fast development.
        </li>
        <li>
            Understand the{' '}
            <Hyperlink linkText="BEM Naming Methodology" navUrl="https://getbem.com" /> and
            specifically how we{' '}
            <Hyperlink
                linkText="use it internally"
                navUrl="/bem-methodology"
                openInNewTab={false}
            />
            .
        </li>
        <li>
            We use <Hyperlink linkText="Sass" navUrl="https://sass-lang.com/" /> as our CSS
            extension language. If you need to learn the basics, this is a{' '}
            <Hyperlink linkText="helpful resource" navUrl="https://sass-lang.com/guide" />.
        </li>
        <li>
            Check out the{' '}
            <Hyperlink
                linkText="Strata monorepo"
                navUrl="https://bitbucket.org/fmhcore/strata/src/master/"
            />
            . This repo contains:
            <ul>
                <li>
                    <span className="font-bold">Strata UI:</span> Color Palette, Design Tokens,
                    Utility Classes, etc.
                </li>
                <li>
                    <span className="font-bold">Sass Themes:</span> How we theme each component in
                    light/dark mode.
                </li>
                <li>
                    <span className="font-bold">Components:</span> All React components styled from
                    Strata UI. Each component repo becomes a versioned NPM package.
                </li>
                <li>
                    <span className="font-bold">Strata UI Strings:</span> Common strings that we
                    share across applications. Required field messaging, max character messaging,
                    etc.
                </li>
            </ul>
        </li>
        <li>
            Some of our components extend{' '}
            <Hyperlink linkText="Blueprint" navUrl="https://blueprintjs.com/" />. We style these
            components with Strata and create NPM packages that are shared across our applications.
            Components are written in <Hyperlink linkText="React" navUrl="https://reactjs.org/" />.
        </li>
    </ul>,
];

export const GettingStartedEngineer = () => (
    <div>
        <Page
            pageTitle="Getting Started as an Engineer"
            pageDescription="A list of engineering resources to help establish the basics of working with the Strata Design System."
            pageContent={<Section title="Start Here" contentArray={startHere} />}
        />
    </div>
);
